<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <section class="clientVoice">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/clientConceptPic3.jpg" />
          </div>
          <div class="solutionConceptBoxL clientCaseBlue">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">用心聆听客户的声音</div>
              <div class="solutionConceptInConn">
                我们是国家下一代互联网示范城市之一，在基于下一代互联网的移动互联网专用网络建设中，遇到IPv4/IPv6用户访问兼容问题，睿哲科技的解决方案，很好地为各个数据交换接口提供协议转换支撑，顺利地解决了相关的技术难题。
                <p>——某市信息化管理局</p>
              </div>
            </div>
            <div class="clientCaseArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="clientIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          注重客户收益，想客户之所想
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon13.png" />
            <div class="solutionIncomeConn">
              通过智能调度，提供更为智能<br />而强大的分布式内容加速服务
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon06.png" />
            <div class="solutionIncomeConn">
              帮助安全数据中心从IPv6系统<br />与外部IPv4数据源实现互联互通
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              行业应用、信息安全的升级<br />为信息安全示范城市提供大数据支撑
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="clientChallenge">
      <div class="clientChallengeBox">
        <img src="../../../static/images/clientChallengeBg1.jpg" />
        <div class="clientChallengeConn">
          <div class="clientChallengeTit">直面挑战，毫不畏惧</div>
          <ul class="clientChallengeList">
            <li>
              <span><i></i></span>提高信息安全性，助力维稳工作
            </li>
            <li>
              <span><i></i></span>为城市管理及交通监控提供全面的技术支持
            </li>
            <li>
              <span><i></i></span
              >利用IPv6协议安全方面的优势，打造立体城市管理盘系统
            </li>
            <li>
              <span><i></i></span
              >推动本市数据业务全面升级，促进政府、学校、企事业单位等<br />&nbsp;&nbsp;&nbsp;&nbsp;外网网站系统的安全改造和升级进程
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="clientSolution">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          成熟的解决方案，难题迎刃而解
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <div class="clientSolutionTit">双栈内容发布平台</div>
            <div class="clientSolutionConn">
              建设双栈内容发布平台，帮助政府网站业务向IPv4/IPv6用户提供访问服务，解决网站外链导致的内容缺失问题(“天窗”问题)，支持智能缓存和内容加速功能，支持DDoS攻击、网络病毒等防范能力
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">IPv6与IPv4互联互通</div>
            <div class="clientSolutionConn">
              研发运营支撑系统，为网站双栈内容发布平台提供图形化的服务开通、设备管理、用户溯源、实时计费和查询统计等功能
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">用户自助服务系统</div>
            <div class="clientSolutionConn">
              研发用户自服务系统作为网上营业厅，主要完成客户售前工作，为客户提供方便快捷的业务申报、费用支付和业务查询等服务，是方便客户，提升体验，降低管理成本的重要手段
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage: "../../../static/images/clientDetailBanner.jpg?0219",
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./case";
.solutionCase {
}
</style>



// WEBPACK FOOTER //
// src/pages/case/caseDetail3.vue